import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, ModalHeader, Typography } from 'common/components';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../../../entrance-doors-constants';

type SoundInsulationProps = {
  onConsultationSignupBtnClick: () => void;
};

export const SoundInsulation = ({ onConsultationSignupBtnClick }: SoundInsulationProps) => (
  <>
    <ModalHeader title="Высокий уровень шумоизоляции" />
    <ModalContent>
      <Typography variant="m" size="body_long">
        Мы&nbsp;изготавливаем входные двери с&nbsp;двумя или тремя контурами уплотнения. В&nbsp;сочетании
        с&nbsp;акустической мембраной и&nbsp;звукоизоляционными материалами такое полотно обеспечит надёжную
        защиту от&nbsp;шума, сквозняков и&nbsp;посторонних запахов, а&nbsp;также от&nbsp;пыли и&nbsp;влаги.
        При установке наши мастера обязательно проконтролируют, чтобы дверь плотно прилегала к&nbsp;коробке,
        что ещё больше повысит уровень шумоизоляции.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK}
        elementText="Оставить заявку"
        elementName="Высокий уровень шумоизоляции"
        onClick={onConsultationSignupBtnClick}
        wide>
        Оставить заявку
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
